import { useEffect } from 'react'
import { toast } from 'sonner'
import { isElectron } from '../utils/platform.js'

export function useAutoUpdate() {
  useEffect(() => {
    if (!isElectron()) return

    window.electronAPI.onUpdateAvailable(() => {
      toast.info('A new version is available. Downloading...')
    })

    window.electronAPI.onUpdateDownloaded(() => {
      toast('Update ready — restart to apply', {
        duration: Infinity,
        action: {
          label: 'Restart',
          onClick: () => window.electronAPI.installUpdate(),
        },
      })
    })

    return () => {
      window.electronAPI.removeUpdateListeners()
    }
  }, [])
}
